const sharedConfig = require("./config.shared");

const isLocalhost =
	typeof window !== "undefined" &&
	(window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const envBaseURL = process.env.REACT_APP_API_BASE_URL
	? process.env.REACT_APP_API_BASE_URL.trim()
	: "";

const normalizedEnvBaseURL = envBaseURL
	? envBaseURL.endsWith("/")
		? envBaseURL
		: `${envBaseURL}/`
	: "";

const browserOrigin =
	typeof window !== "undefined" && window.location && window.location.origin
		? `${window.location.origin}/`
		: "/";

export const baseURL = isLocalhost
	? sharedConfig.devBaseURL
	: normalizedEnvBaseURL || sharedConfig.prodBaseURL || browserOrigin;
export const secretKey = sharedConfig.secretKey;
export const projectName = sharedConfig.projectName;
export const folderStructurePath = sharedConfig.folderStructurePath;
export const bucketName = sharedConfig.bucketName;
export const hostname = sharedConfig.hostname;
export const aws_access_key_id = sharedConfig.aws_access_key_id;
export const aws_secret_access_key = sharedConfig.aws_secret_access_key;
